import Api from '../utils/Api';

//LICENSE
export const sendInvite = (token, body) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.post(`share-account/send`, body, config);
};

export const getInvitedUsersList = (token, ownerEmail, status = null) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  let url = `share-account/invited-users/${ownerEmail}?status=${status ? status : ""}`;
  return Api.get(url, config);
};

export const getInvitationsList = (token, guestEmail, status = null) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.get(`invitations/${guestEmail}` + `?status=${status}`, config);
} 
